<mat-form-field appearance="fill">
  <input
    type="text"
    matInput
    #searchInput
    [(ngModel)]="typedInput"
    placeholder="{{placeholder || ''}}"
    [matAutocomplete]="matDropdown"
    (blur)="onTouched()"
    [disabled]="disabled"
    (keyup.enter)="search()"
  />
  <button matSuffix mat-icon-button aria-label="Search" (click)="search()">
    @if ({loadingState:(loading | async)}; as data) { @if (!(data.loadingState)) {
    <mat-icon>search</mat-icon>
    } @if (data.loadingState) {
    <mat-icon svgIcon="loadingBounce"></mat-icon>
    } }
  </button>
  <mat-autocomplete class="dropdown-panel" #matDropdown="matAutocomplete">
    @if (autocompleteHits$ | async; as filtered) { @for (option of filtered.items; track option) {
    <mat-option [value]="option" (click)="selectChoice(option)">
      @switch ($any(option)?.type?.id) { @case ('person') { @if (!$any(option)?.title?.toLowerCase().includes('team')) {
      <search-title stylesAccentColour="publish-colour">
        <ng-container image>
          <elements-image-base
            size="30px"
            [imageUrl]="'https://profile-images.internal.brafton.com/profile-images/profile-image-' + $safeNavigationMigration($any(option)?.user?.id) + '.jpg'"
          ></elements-image-base>
        </ng-container>
        <ng-container top>
          <span [innerHtml]="option?.highlight?.['owner'] || $any(option)?.user?.name"></span
        ></ng-container>
        <ng-container bottom> <mat-icon>people</mat-icon> {{$any(option)?.type?.name}} </ng-container>
      </search-title>
      } @if ($any(option)?.title?.toLowerCase().includes('team')) {
      <search-title stylesAccentColour="publish-colour">
        <ng-container image>
          <elements-image-base size="30px" imageUrl="/assets/images/fallback/generic.png"></elements-image-base>
        </ng-container>
        <ng-container top>
          <span [innerHtml]="option?.highlight?.['owner'] || $any(option)?.organization?.name"></span
        ></ng-container>
        <ng-container bottom> <mat-icon>people</mat-icon> Team </ng-container>
      </search-title>
      } } @case ('organization') {
      <search-title stylesAccentColour="slate">
        <ng-container image>
          <mat-icon>corporate_fare</mat-icon>
        </ng-container>
        <ng-container top>
          <span [innerHtml]="option?.highlight?.['owner'] || $any(option)?.organization?.name"></span
        ></ng-container>
        <ng-container bottom> <mat-icon>corporate_fare</mat-icon> {{$any(option)?.type?.name}} </ng-container>
      </search-title>
      } @case ('contract') {
      <search-title stylesAccentColour="not-tiffany">
        <ng-container image>
          <mat-icon>receipt</mat-icon>
        </ng-container>
        <ng-container top>
          <span [innerHtml]="option?.highlight?.['owner'] || $any(option)?.organization?.name"></span>
        </ng-container>
        <ng-container bottom> <mat-icon>receipt</mat-icon> {{$any(option)?.type?.name}} </ng-container>
      </search-title>
      } @case ('comment') {
      <search-title stylesAccentColour="orange">
        <ng-container image>
          <mat-icon>message</mat-icon>
        </ng-container>
        <ng-container top>
          <span [innerHtml]="option?.highlight?.['owner'] || option?.organization?.name || option?.project?.name"></span
        ></ng-container>
        <ng-container bottom> <mat-icon>message</mat-icon> {{$any(option)?.type?.name}} </ng-container>
      </search-title>
      } @case ('assetfile') {
      <search-title stylesAccentColour="fresh-caught-salmon">
        <ng-container image>
          <mat-icon>folder</mat-icon>
        </ng-container>
        <ng-container top>
          {{$any(option)?.type?.name}}
          <mat-icon>chevron_right</mat-icon>
          <span [innerHtml]=" $safeNavigationMigration($any(option)?.title)"></span
        ></ng-container>
        <ng-container bottom>
          <mat-icon>corporate_fare</mat-icon> {{$any(option)?.organization?.name || $any(option)?.project?.name}}
        </ng-container>
      </search-title>
      } @case ('textset') {
      <search-title stylesAccentColour="not-tiffany">
        <ng-container image>
          <mat-icon>description</mat-icon>
        </ng-container>
        <ng-container top>
          {{$any(option)?.project?.name}}
          <mat-icon>chevron_right</mat-icon>
          <span [innerHtml]=" $safeNavigationMigration($any(option)?.title)"></span
        ></ng-container>
        <ng-container bottom>
          <mat-icon>corporate_fare</mat-icon> {{$any(option)?.organization?.name || $any(option)?.project?.name}}
        </ng-container>
      </search-title>
      } @case ('content') {
      <search-title stylesAccentColour="purple">
        <ng-container image>
          <mat-icon>picture_in_picture</mat-icon>
        </ng-container>
        <ng-container top>
          {{$any(option)?.type?.name}}
          <mat-icon>chevron_right</mat-icon>
          <span [innerHtml]=" $safeNavigationMigration($any(option)?.title)"></span
        ></ng-container>
        <ng-container bottom>
          <mat-icon>corporate_fare</mat-icon> {{$any(option)?.organization?.name || $any(option)?.project?.name}}
        </ng-container>
      </search-title>
      } @case ('campaign') {
      <search-title stylesAccentColour="armageddon-dust">
        <ng-container image>
          <mat-icon>campaign</mat-icon>
        </ng-container>
        <ng-container top> <span [innerHtml]="$safeNavigationMigration($any(option)?.title)"></span></ng-container>
        <ng-container bottom>
          <mat-icon>campaign</mat-icon> {{$any(option)?.organization?.name}} @if ($any(option)?.organization?.name) {
          <mat-icon>chevron_right</mat-icon>
          } Campaign
        </ng-container>
      </search-title>
      } @case ('project') { @if ($any(option)?.type !== 'StatementOfWork' && $any(option)?.project?.module !==
      'Campaign') {
      <search-title stylesAccentColour="tuscan-sun">
        <ng-container image>
          <mat-icon>dataset</mat-icon>
        </ng-container>
        <ng-container top>
          <span [innerHtml]="$safeNavigationMigration($any(option)?.project?.name) "></span
        ></ng-container>
        <ng-container bottom>
          <mat-icon>corporate_fare</mat-icon> {{$any(option)?.organization?.name || "Project"}}
        </ng-container>
      </search-title>
      } @if ($any(option)?.type === 'StatementOfWork') {
      <search-title stylesAccentColour="not-tiffany">
        <ng-container image>
          <mat-icon>receipt</mat-icon>
        </ng-container>
        <ng-container top> <span [innerHtml]="$safeNavigationMigration($any(option)?.title)"></span></ng-container>
        <ng-container bottom>
          <mat-icon>receipt</mat-icon> {{$any(option)?.organization?.name || 'Contract'}}
        </ng-container>
      </search-title>
      } @if ($any(option)?.type !== 'StatementOfWork' && $any(option)?.project?.module === 'Campaign') {
      <search-title stylesAccentColour="armageddon-dust">
        <ng-container image>
          <mat-icon>campaign</mat-icon>
        </ng-container>
        <ng-container top> <span [innerHtml]="$safeNavigationMigration($any(option)?.title)"></span></ng-container>
        <ng-container bottom>
          <mat-icon>campaign</mat-icon> {{$any(option)?.organization?.name}} @if ($any(option)?.organization?.name) {
          <mat-icon>chevron_right</mat-icon>
          } Campaign
        </ng-container>
      </search-title>
      } } @default {
      <search-title stylesAccentColour="fresh-caught-salmon">
        <ng-container image>
          <mat-icon>not_listed_location</mat-icon>
        </ng-container>
        <ng-container top>
          {{$any(option)?.type?.name}} @if ($any(option)?.title) {
          <mat-icon>chevron_right</mat-icon>
          }
          <span [innerHtml]=" $safeNavigationMigration($any(option)?.title)"></span
        ></ng-container>
        <ng-container bottom>
          <mat-icon>not_listed_location</mat-icon> {{$any(option)?.organization?.name || $any(option)?.project?.name}}
        </ng-container>
      </search-title>
      } }
    </mat-option>
    }
    <!-- <mat-option *ngFor="let suggest of updateSuggestions(filtered.suggest)">
                        <elements-view-option-chip caption="Test"> </elements-view-option-chip>
                      </mat-option> -->
    }
  </mat-autocomplete>
</mat-form-field>
